import React from 'react'
import styled from '@emotion/styled'
import HeadingBorder from 'src/components/atoms/HeadingBorder'
import MoreRead from 'src/components/atoms/MoreRead'
import AccordionMenu from 'src/components/molecules/AccordionMenu'
import { BreakPoint } from 'src/components/shared/CssValues'
import { Typography } from 'src/components/atoms/Typography'

// answerには文字列でhtmlを渡せる
const QA = [
  {
    question: '立ち上げにどの程度時間がかかるの？',
    answer:
      '機能カスタマイズや貴社データとの連携等により前後しますが、成功確度を最大限高めるために独自の顧客コミュニティリリースまで4〜8週間程度を見込んでおります。ただし、立ち上げの際には経験豊富な弊社カスタマーサクセス担当が戦略検討からサポートさせていただきますので、貴社の負担は最小限で開始できます。'
  },
  {
    question: '立ち上げ後、自社リソースはどの程度必要になるの？',
    answer:
      'commmune をご活用いただく場合、顧客コミュニティの運用・保守には約0.2人月、一般的な工数の1/5〜1/10程度で済みます。高い機能性と弊社カスタマーサクセス担当のサポートによりユーザー管理やデータ分析等にかかるリソースが大幅に軽減され、担当者様は高付加価値業務に集中できます。'
  },
  {
    question: '費用はどの程度かかるの？',
    answer:
      'commmuneでは、機能・カスタマイズ性・参加人数の程度により、ライトプランからエンタープライズプランまで4プランをご用意しております。貴社ニーズに合わせて最適なプランを柔軟にご提案させていただきますので、詳しくは<a href="/contact">お問い合わせ</a>ください。'
  }
]

export const Faq = () => {
  return (
    <Contents>
      <ContentsLeft>
        <HeadingBorder heading="FAQ" />
        <HeadText as="h2">よくある質問</HeadText>
      </ContentsLeft>
      <ContentsRight>
        <FaqBox>
          {QA.map((data, i) => (
            <FaqLine key={i} index={i}>
              <AccordionMenu question={data.question} answer={data.answer} />
            </FaqLine>
          ))}
        </FaqBox>
      </ContentsRight>
    </Contents>
  )
}

const HeadText = styled(Typography)`
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.5;
  letter-spacing: 1.92px;
  text-align: left;
  color: #22475d;
  margin-top: 3px;
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    font-size: 17.5px;
  }
`

const Contents = styled.div`
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    flex-direction: column;
  }
`

const ContentsLeft = styled.div`
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    width: 100%;
  }
`

const ContentsRight = styled.div`
  width: 68.686%;
  @media screen and (max-width: ${BreakPoint.TABLET_MIN_WIDTH}) {
    width: 64.686%;
  }
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    width: 100%;
    padding-top: 32px;
  }
`

const FaqBox = styled.div`
  display: flex;
  flex-direction: column;
`

type FaqLineProps = {
  index: number
}

const FaqLine = styled.div<FaqLineProps>`
  padding-bottom: 30px;
  padding-top: ${({ index }) => (index !== 0 ? '30px' : '0')};
  border-top: ${({ index }) => (index !== 0 ? 'solid 1px #D1D1D1' : '0')};
`

// WARN: SP・PCで配置する位置が異なるため、SP・PCでMoreReadWrapperとSPMoreReadWrapperの表示の有無を切り替える必要がある
const MoreReadWrapper = styled.div`
  display: block;
  margin-top: 40px;

  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    display: none;
  }
`

const SPMoreReadWrapper = styled.div`
  display: none;
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    display: flex;
    justify-content: flex-end;
    margin: 30px 0 0 0;
  }
`
